import {dedupeFieldMappingsForSave, resolveSettingMappingIdForSave} from './fieldMappingSaveUtils'

/** Set localStorage MC_DEBUG_CHANNEL_SETTINGS_SAVE=1 in DevTools to block saves and inspect payloads. */
export const CHANNEL_SETTINGS_SAVE_DEBUG_KEY = 'MC_DEBUG_CHANNEL_SETTINGS_SAVE'

export const isChannelSettingsSaveDebugEnabled = (): boolean =>
  typeof window !== 'undefined' &&
  localStorage.getItem(CHANNEL_SETTINGS_SAVE_DEBUG_KEY) === '1'

export const isChannelSettingsSaveDebugEndpoint = (
  method: string,
  endPoint: string
): boolean => {
  if (method !== 'POST') return false
  return (
    endPoint.includes('create-platform-settings') ||
    endPoint.includes('field-mapping-with-setting')
  )
}

type InspectChannelSettingsSaveArgs = {
  settingsPayload: Record<string, unknown>
  fieldMappings: Record<string, unknown>[]
  savedMappings?: Record<string, unknown>[]
  platformSettings?: Record<string, any> | null
  selectedPlatformId?: string | number | null
}

const buildFieldMappingSavePreview = ({
  fieldMappings,
  savedMappings = [],
  platformSettings,
}: Pick<
  InspectChannelSettingsSaveArgs,
  'fieldMappings' | 'savedMappings' | 'platformSettings'
>) => {
  const normalizedFieldMappings = dedupeFieldMappingsForSave(fieldMappings, savedMappings)

  return normalizedFieldMappings.map((settingField) => {
    const groupContainer = platformSettings?.[settingField.groupCode as string]
    const groupId = groupContainer?.id ?? `(pending ${settingField.groupCode}_id from settings save)`

    const mappingDataset = settingField.fieldMappingDataSet || []
    const mapping_for_save = mappingDataset.map((item: Record<string, unknown>) => ({
      ...(item?.id ? {id: item.id} : {}),
      source_platform_data_id: item?.source_platform_data_id ?? null,
      destination_platform_data_id: item?.destination_platform_data_id ?? null,
      source_platform_data_str: item?.source_platform_data_str ?? '',
      destination_platform_data_str: item?.destination_platform_data_str ?? '',
      isDefault: settingField?.isDefault,
    }))

    return {
      [`${settingField.groupCode}_id`]: groupId,
      field_mapping_id: settingField.field_mapping_id ?? settingField.savedMappingId ?? null,
      isDefault: settingField?.isDefault,
      setting_mapping_id: resolveSettingMappingIdForSave(settingField, savedMappings),
      source_field_id: settingField.sourceFieldId ?? null,
      destination_field_id: settingField.destinationFieldId ?? null,
      fieldmappingdata_set: mapping_for_save,
      fieldCode: settingField.fieldCode,
      mappingKey: settingField.mappingKey,
    }
  })
}

export const inspectChannelSettingsSaveBeforeApi = ({
  settingsPayload,
  fieldMappings,
  savedMappings = [],
  platformSettings,
  selectedPlatformId,
}: InspectChannelSettingsSaveArgs): void => {
  const fieldMappingSavePreview = buildFieldMappingSavePreview({
    fieldMappings,
    savedMappings,
    platformSettings,
  })

  const locationMappings = fieldMappingSavePreview.filter(
    (entry) => `${entry.fieldCode ?? ''}`.toUpperCase() === 'LOCATION'
  )

  console.group('[MC_DEBUG_CHANNEL_SETTINGS_SAVE] Save blocked — inspect payloads below')
  console.log('selectedPlatformId', selectedPlatformId)
  console.log('settingsPayload (POST create-platform-settings)', settingsPayload)
  console.log('fieldMappings state', fieldMappings)
  console.log('field-mapping-with-setting preview', fieldMappingSavePreview)
  if (locationMappings.length) {
    console.warn('LOCATION mapping preview (check isDefault)', locationMappings)
  }
  console.groupEnd()

  // eslint-disable-next-line no-debugger
  debugger
}
